<template>
  <div class="footer_container">
    <div class="footer-wrapper-top">
      <div class="footer-inner-top">
        <div class="footer-links" :class="columns">

          <div class="logo-details-area">
            <div class="footer-logo"></div>
            <a
              class="footer-links-main "
              target="_blank"
              href="telephone: +1 412-472 5050"
              title="Terminal Map"
              ><i class="fas fa-phone" style="transform: scaleX(-1)"></i> LAZ Parking Offices: 412-472 5050</a
            >
            <a
              class="footer-links-main"
              target="_blank"
              href="mailto:PIT@lazparking.com"
              title="Terminal Map"
              ><i class="far fa-envelope"></i> PIT@lazparking.com</a
            >
            <span class="footer-links-main"><i class="fas fa-map-marker-alt"></i> 1000 Airport blvd, Pittsburgh PA 15231</span>
          </div>

          <div class="chevron">
            <div class="footer-links-heading">Resources</div>
            <a
              class="footer-links-main pit-yellow"
              target="_blank"
              href="https://www.pittransformed.com/"
              title="PIT TRANSFORMED"
              >PIT TRANSFORMED</a
            >
            <a
              class="footer-links-main pit-yellow"
              target="_blank"
              href="https://www.visitpittsburgh.com/"
              title="VISIT PITTSBURGH"
              >VISIT PITTSBURGH</a
            >
            <a
              class="footer-links-main pit-yellow"
              target="_blank"
              href="https://flypittsburgh.com/acaa-corporate/join-our-team/career-opportunities/"
              title="CAREERS"
              >CAREERS</a
            >
            <a
              class="footer-links-main pit-yellow"
              target="_blank"
              href="https://flypittsburgh.com/pittsburgh-international-airport/contact-us/pit-faqs/"
              title="FAQs"
              >FAQs</a
            >
            <a
              class="footer-links-main pit-yellow"
              target="_blank"
              href="https://flypittsburgh.com/pittsburgh-international-airport/contact-us/"
              title="CONTACT US"
              >CONTACT US</a
            >
          </div>

          <div class="chevron">
            <div class="footer-links-heading">PIT International Airport</div>
            <a
              class="footer-links-main"
              target="_blank"
              href="https://flypittsburgh.com/pittsburgh-international-airport/flights/flight-status/"
              title="FLIGHTS"
              >FLIGHTS</a
            >
            <a
              class="footer-links-main"
              target="_blank"
              href="https://flypittsburgh.com/pittsburgh-international-airport/parking/"
              title="PARKING"
              >PARKING</a
            >
            <a
              class="footer-links-main"
              target="_blank"
              href="https://flypittsburgh.com/pittsburgh-international-airport/security/"
              title="SECURITY"
              >SECURITY</a
            >
            <a
              class="footer-links-main"
              target="_blank"
              href="https://flypittsburgh.com/pittsburgh-international-airport/accessibility/"
              title="ACCESSIBILITY"
              >ACCESSIBILITY</a
            >
          </div>

          <div class="chevron">
            <div class="footer-links-heading">Allegheny County Airport</div>
            <a
              class="footer-links-main"
              target="_blank"
              href="https://flypittsburgh.com/allegheny-county-airport/business-opportunities/"
              title="BUSINESS OPPORTUNITIES"
              >BUSINESS OPPORTUNITIES</a
            >
            <a
              class="footer-links-main"
              target="_blank"
              href="https://flypittsburgh.com/allegheny-county-airport/pilot-resources/aeronautical-information/"
              title="AERONAUTICAL INFO"
              >AERONAUTICAL INFO</a
            >
            <a
              class="footer-links-main"
              target="_blank"
              href="https://flypittsburgh.com/allegheny-county-airport/pilot-resources/landing-fees-and-payments/"
              title="LANDING FEES"
              >LANDING FEES</a
            >
          </div>

          <div class="chevron">
            <div class="footer-links-heading">Airport Authority</div>
            <a
              class="footer-links-main"
              target="_blank"
              href="https://flypittsburgh.com/acaa-corporate/join-our-team/career-opportunities/"
              title="CAREER OPPORTUNITIES"
              >CAREER OPPORTUNITIES</a
            >
            <a
              class="footer-links-main"
              target="_blank"
              href="https://flypittsburgh.com/acaa-corporate/partner-with-us/business-opportunities/"
              title="BUSINESS OPPORTUNITIES"
              >BUSINESS OPPORTUNITIES</a
            >
            <a
              class="footer-links-main"
              target="_blank"
              href="https://flypittsburgh.com/acaa-corporate/join-our-team/airport-badging/"
              title="AIRPORT BADGING"
              >AIRPORT BADGING</a
            >
            <a
              class="footer-links-main"
              target="_blank"
              href="https://flypittsburgh.com/acaa-corporate/newsroom/reports-financials/"
              title="REPORTS"
              >REPORTS</a
            >
          </div>
        </div>
      </div>
    </div>

    <div class="footer-wrapper-bottom">
      <div class="footer-inner-bottom">
        <span class="footer-links-main">© {{ new Date().getFullYear() }} Allegheny County Airport Authority</span>
        <span class="policy-links">
          <a
            target="_blank"
            href=""
            >Privacy Policy</a
          >
          &nbsp;&nbsp;&nbsp;&nbsp;
          <span>Powered by Rezcomm</span>
        </span>
        <span class="socila_links">

          <a href="https://www.facebook.com/PITairport" target="_blank" rel="noopener" title="Facebook" aria-label="Facebook" style="margin-right: 0.5rem;">
            <i class="fab fa-facebook-f"></i>
          </a>

          <a href="https://x.com/PITairport" target="_blank" rel="noopener" title="X (Twitter)" aria-label="X (Twitter)">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="width:1em;height:1em;vertical-align:middle;fill:#B2B2B1;"><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/></svg>
          </a>

          <!-- <a href="https://x.com/PITairport" target="_blank" rel="noopener" title="X (Twitter)" aria-label="X (Twitter)" style="margin-right: 0.5rem;">
            <i class="fab fa-x-twitter"></i>
          </a> -->

          <a href="https://www.instagram.com/pitairport/" target="_blank" rel="noopener" title="Instagram" aria-label="Instagram" style="margin-right: 0.5rem;">
            <i class="fab fa-instagram"></i>
          </a>

          <a href="https://www.youtube.com/@PittsburghInternationalAirport" target="_blank" rel="noopener" title="YouTube" aria-label="YouTube" style="margin-right: 0.5rem;">
            <i class="fab fa-youtube"></i>
          </a>

          <a href="https://www.linkedin.com/company/pittsburghinternationalairport" target="_blank" rel="noopener" title="LinkedIn" aria-label="LinkedIn">
            <i class="fab fa-linkedin-in"></i>
          </a>
        </span>
      </div>
    </div>
    <div style="clear: both"></div>
  </div>

  <!-- <div 
    class="cookie-settings-float" 
    :style="cookieBackgroundImage()"
    @click="toggle_cookie_settings()"
    >
    <span><i class="fas fa-cookie-bite"></i>&nbsp;&nbsp;Cookie settings</span>
  </div> -->
</template>

<script>
export default {
  name: "Footer",
  props: {
    footer_links: undefined,
    footer_columns: undefined,
  },
  computed: {
    columns: function () {
      return "grid-" + this.footer_columns.toLowerCase().replaceAll(" ", "-");
    },
  },
  data() {
    return {
      copyright:
        "© 2025 Allegheny County Airport Authority",
      poweredby: "",
    };
  },
  methods: {
    
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/sass/variables.scss";

.footer_container {
  height: auto;
  position: relative;
}

.footer-wrapper-top,
.footer-wrapper-bottom {
  margin: 0;
  padding: 0;
  width: 100%;
  float: left;
}

.footer-wrapper-top {
  border-top: 1px solid var(--footer_top_border_top_color);
  background-color: var(--footer_top_background_color, $footer-top-bg);
  color: var(--footer_top_text_color, $footer-top-text);
  font-family: var(--footer_top_font_family, $footer-top-font);
  font-size: var(--footer_top_font_size, 1rem);
  font-weight: var(--footer_top_font_weight, normal);
}

.footer-wrapper-bottom {
  background-color: var(--footer_bottom_background_color, $footer-bottom-bg);
  color: var(--footer_bottom_text_color, $footer-bottom-text);
  font-family: var(--footer_bottom_font_family, $footer-bottom-font);
  font-size: var(--footer_bottom_font_size, 1rem);
  font-weight: var(--footer_bottom_font_weight, normal);
}

.footer-inner-top {
  max-width: calc(1280px + 2rem);
  margin: 0 auto;
  display: flex;
  .footer-links {
    padding: 4rem 1rem 3rem;
    display: grid;
    width: 100%;

    grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
    grid-gap: 1rem;

    a, span {
      margin: 10px 0;
    }

    span {
      pointer-events: none;
    }

    @media screen and (max-width: 768px) {
      grid-template-columns: 1fr !important;
      a, span {
        margin: 10px 0;
      }
    }

    &-heading {
      color: #ddd;
      font-size: .9rem;
      font-weight: bold;
      margin-bottom: 0.5rem;
    }

    &-main {
      display: block;
    }
  }
  .footer-links span,
  .footer-links a {
    color: #B2B2B1;
    text-decoration: none;
    // padding: 0 30px 0 0;
    padding: 0rem 0 0rem 0rem;
    font-size: 0.8rem;
    font-weight: 400;
    // make font uppercase
    text-transform: uppercase;
    &:hover {
      text-decoration: underline;
    }
    @media screen and (max-width: 768px) {
      padding: 0 10px;
    }
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
}
.footer-links .chevron span,
.footer-links .chevron a {
  padding: .25rem 0;
}

.footer-wrapper-top-extra {
  border-top: 0px;
  background-color: #101e34;
}

.footer-links-extra.footer-links-extra {
  i {
    font-size: 1.25rem;
  }
  a {
    font-size: 1rem;
  }
}

.footer-inner-bottom {
  border-top: 1px solid var(--footer_bottom_border_top_color);
  padding: 30px 10px;
  max-width: calc(1280px + 2rem);
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  color: $footer-bottom-text;
  font-size: 0.825rem;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    padding: 30px 30px;
    span {
      padding: 20px 0;
    }
  }
}

.policy-links {
  a {
    color: #fff;
    padding: 0 1.5rem 0 0;
  }
}


.cookie-settings-float {
  position: fixed;
  bottom: 2rem;
  left: 0;
  padding: 10px 20px;
  border-top: none;
  border-left: none;
  cursor: pointer;
  z-index: 99999999;
  display: flex;
  flex-wrap: nowrap;
  align-self: flex-start;
  background-size: cover;
  background-repeat: no-repeat;
  background-position-y: center;
  -moz-transform: scaleX(-1);
  -o-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  box-shadow: 0 8px 8px -4px rgba(0, 0, 0, 0.2);
  span {
    -moz-transform: scaleX(-1);
    -o-transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    color: #fff;
  }
}

.footer-logo {
  width: var(--footer_logo_width);
  height: var(--footer_logo_height);
  background-image: var(--footer_logo);
  background-size: contain;
  background-repeat: no-repeat;
  align-items: center;
  display: var(--footer_logo_active, none);
  justify-content: center;
  @media screen and (max-width: 768px) {
    width: var(--footer_logo_width);
  }
}

.logo-details-area {
  a, span {
    font-size: .8rem;
    padding-top: 1rem !important;
  }
}

.pit-yellow {
  color: #FCBC00 !important;
}

.footer-inner-bottom a, .footer-inner-bottom span {
    color: #B2B2B1;
    text-decoration: none;
    padding: 0rem 0 0rem 0rem;
    font-size: 0.8rem;
    font-weight: 400;
}
.footer-links-main{
  text-align: left;
}

.logo-details-area.logo-details-area .footer-links-main{
  text-transform: unset;
}

.footer-links-heading{
  text-align: left;
}

.socila_links {
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: flex-end;
}

</style>
